import { render, staticRenderFns } from "./access-control-config-form.vue?vue&type=template&id=7969ca6d&scoped=true&"
import script from "./access-control-config-form.vue?vue&type=script&lang=ts&"
export * from "./access-control-config-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7969ca6d",
  null
  
)

export default component.exports